import { Select as BaseSelect } from "@base-ui/react/select";

import type { SelectBackdropProps } from "./Select.types";

export function SelectBackdrop({ ...props }: SelectBackdropProps) {
  return <BaseSelect.Backdrop data-slot="select-backdrop" {...props} />;
}
